@for (banner of this.globalBanners | async; track banner) {
  <app-information-banner [banner]="banner"></app-information-banner>
}
<router-outlet></router-outlet>
